import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Title from '../Title';
import FieldError from '../FieldError';
import { isString } from '../../utils/validations';
import { errors } from '../../constants';

import { Box, Button, Card, CardContent, Divider, EntityLabel, EntityLabelGroup, TextField, Typography } from '@otcmarketsgroup/otcm-ui-lib';

const QuestionCard = ({ item, section, handleQuestionClick, readOnly, isValid = true, disabled, onValueChanged, onShowDetail, showError }) => {
  const [isFocus, setFocus] = useState(false);
  const value = section && section[item.fieldName];
  const isNoSelected = value === false;
  const isYesSelected = value === true;
  const showDetails = (value === true || value === false);
  const SubTitleComponent = item.subTitle;
  const isComponent = typeof SubTitleComponent === 'function';
  const ExtraInfoComponent = item.extraInfo;
  const isExtraInfoComponent = typeof ExtraInfoComponent === 'function';

  const renderDetail = detailObj => {
    if (detailObj.component) {
      const renderComponent = detailObj.component;
      return <>
        <Divider />
        {typeof renderComponent === 'function' ? renderComponent() : renderComponent}
      </>;
    }

    return detailObj.map((obj, i) => {
      const DescComponent = obj.desc;
      const isDescComponent = typeof DescComponent === 'function';

      if (onShowDetail && !onShowDetail(obj)) {
        return;
      }

      return <>
        <Divider />
        <div key={i}>
          {isDescComponent ? <DescComponent /> : <div>
            {obj.desc}
          </div>}
          {!obj.hideDetails && <TextField
            label="Details"
            placeholder={obj.placeholder || 'Enter text here.'}
            minRows={2}
            maxLength={1500}
            multiline
            showCharCounter
            readOnly={readOnly}
            disabled={disabled}
            value={section[obj.fieldName] ? section[obj.fieldName] : ''}
            error={showError &&!isString(section[obj.fieldName])}
            helperText={showError && !isString(section[obj.fieldName]) ? errors.INCOMPLETE_DATA_FIELD : ""}
            onChange={e => onValueChanged(e.target.value, obj.fieldName)} />}
        </div>
      </>;
    });
  };

  return <Card hasBorder
    type={!isValid ? 'warning' : 'primary'}
    onMouseOver={() => setFocus(true)}
    onMouseOut={() => setFocus(false)}
  >
    <CardContent>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Title type='h3' title={item.title} />
          {!isValid && <FieldError isFocus={isFocus} error={errors.INCOMPLETE_DATA_FIELD} />}
        </Box>
        {isComponent ? <SubTitleComponent /> : <Typography variant='body1'>
          {item.subTitle}
        </Typography>}
        {!item.options && <Box display='flex' gap={2}>
          <Button disabled={readOnly || disabled} variant={isNoSelected ? 'contained' : 'outlined'} onClick={() => handleQuestionClick(false, item.fieldName)}>No</Button>
          <Button disabled={readOnly || disabled} variant={isYesSelected ? 'contained' : 'outlined'} onClick={() => handleQuestionClick(true, item.fieldName)}>Yes</Button>
        </Box>}
        {item.options && <EntityLabelGroup>
          {item.options.map((option, i) => <EntityLabel
            key={i}
            title={option.text}
            subtitle='Select'
            isComplete
            onEntityClick={() => handleQuestionClick(option.value, item.fieldName)} />)}
        </EntityLabelGroup>}
        {showDetails && <>
          {(!value && item.falseDetails) && renderDetail(item.falseDetails)}
          {(value && item.trueDetails) && renderDetail(item.trueDetails)}
        </>}

        {isExtraInfoComponent ? <ExtraInfoComponent /> : item.extraInfo && <Typography variant='body1'>{item.extraInfo}</Typography>}
      </Box>
    </CardContent>
  </Card>;
};

QuestionCard.propTypes = {
  item: PropTypes.object,
  section: PropTypes.object,
  type: PropTypes.oneOf(['primary', 'secondary', 'nested']),
  isValid: PropTypes.bool,
  handleQuestionClick: PropTypes.func,
  readOnly: PropTypes.bool,
  disabled: PropTypes.bool,
  onValueChanged: PropTypes.func,
  onShowDetail: PropTypes.func
};

export default QuestionCard;
